<template>
  <v-dialog v-model="login" persistent max-width="370" class="mt-n10" v-if="!isLoggedIn">
    <template v-slot:activator="{ on }">
      <v-btn class="icon-btn" depressed small v-on="on">
        <font-awesome-icon class="mr-2" :icon="['fas', 'sign-in-alt']" />
        Войти
      </v-btn>
    </template>
    <v-card class="pl-9 pt-4 pr-9 pb-3">
      <v-row justify='end' class="mb-4">
        <v-btn icon @click="login = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <auth></auth>
    </v-card>
  </v-dialog>
  <div class="text-center" v-else>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn class="icon-btn" depressed small v-on="on">
          <font-awesome-icon class="mr-2" :icon="['fas', 'user-circle']" /> {{ userLogin }}
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item @click="$router.push('/settings')">
          <v-list-item-content>
            <v-list-item-title>
              <font-awesome-icon class="mr-2" :icon="['fas', 'cog']" /> Настройки</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logoutUser">
          <v-list-item-content>
            <v-list-item-title>
              <font-awesome-icon class="mr-2" :icon="['fas', 'sign-out-alt']" /> Выйти</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AuthBtnView',

  components: {
    auth: () => import(
      '@/components/core/Auth'
    )
  },


  data: () => ({
    login: false
  }),

  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isAuthenticated',
      userLogin: 'user/userLogin'
    })
  },

  methods: {
    logoutUser: async function() {
      try {
        //const resp = await this.$api.Account.loginUser({'username_or_token': this.name, 'password': this.password})
        await this.$store.dispatch('user/authLogOut')
        //this.$router.push('/')
        location.href = location.href
      } catch (e) {
        const err = e
        let error = 'Во время выполнения запроса произошла ошибка'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        // console.error(e)
      }
    }
  }

}

</script>
<style scoped>
.icon-btn {
  color: grey;
}

.user-icon {
  color: #FFB74D;
  font-size: 70pt;
}

</style>
